export default __webpack_public_path__ + "aa867391c311267af5a998d11193bc48.svg";